<template>
  <div class="lge-root" :style="rootStyle">
    <svg class="lge-svg" aria-hidden="true">
      <defs>
        <filter :id="filterId" primitiveUnits="objectBoundingBox">
          <feImage :href="originalDisplacementMap" preserveAspectRatio="none" result="map" />
          <feGaussianBlur in="SourceGraphic" :stdDeviation="blur" result="blurred" />
          <feDisplacementMap
            in="blurred"
            in2="map"
            :scale="displacement"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
    <slot />
  </div>
</template>

<script>
import { originalDisplacementMap } from "@/utils/displacement-map";

let _count = 0;

export default {
  name: "LiquidGlassEffect",
  props: {
    width:        { type: String, default: null },
    height:       { type: String, default: null },
    borderRadius: { type: String, default: null },
    blur:         { type: [String, Number], default: "0.004" },
    displacement: { type: [String, Number], default: ".1" },
  },
  data() {
    return {
      filterId: `lge-${++_count}`,
      originalDisplacementMap,
    };
  },
  computed: {
    rootStyle() {
      return {
        backdropFilter:       `url(#${this.filterId})`,
        WebkitBackdropFilter: `url(#${this.filterId})`,
        ...(this.width        && { width:        this.width }),
        ...(this.height       && { height:       this.height }),
        ...(this.borderRadius && { borderRadius: this.borderRadius }),
      };
    },
  },
};
</script>

<style scoped>
/* zero-size SVG — filter lives in <defs>, renders nothing, never clips */
.lge-svg {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
  overflow: visible;
}
</style>
